import { useQueryClient } from "@tanstack/react-query";

import type { BankAccount } from "@/schemas/index";

import { getBankAccount, updateBankAccount } from "../api/bankAccountApi";
import { QueryKeys } from "../queryKeys";
import { useCustomMutation, useCustomQuery } from "../queryUtils";

export function useGetBankAccountQuery() {
  return useCustomQuery([QueryKeys.BANK_ACCOUNT], getBankAccount, {
    staleTime: 60_000,
  });
}

export function useUpdateBankAccountMutation() {
  const queryClient = useQueryClient();
  return useCustomMutation<{ bank_details: BankAccount }, Error, BankAccount>(
    updateBankAccount,
    () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.BANK_ACCOUNT] });
    },
  );
}
